{
  "assets": {
    "MapIcon": "Icon",
    "Model": "3D Model",
    "none_selected_warning": "You must have a {{ assetType }} selected",
    "all_categories": "All categories",
    "select": "Select {{ assetType }}",
    "search_placeholder": "Search for {{ assetType }}"
  },
  "layerTemplates": {
    "selectTemplateText": "Search layer templates",
    "createCustomLayer": "Create custom layer",
    "startFromScratch": "start a new layer from scratch",
    "failedToLoadTemplates": "Failed to load layer templates",
    "failedToLoadLayer": "Failed to load layer",
    "noLayerTemplates": "We can't find any templates with that name. Would you like to start a new layer without using a template instead?",
    "searchPlaceholder": "E.g. Transportation",
    "allTemplates": "All templates",
    "searchResults": "Search results"
  },
  "toolbarButtonTooltips": {
    "draw_map_object": "Draw",
    "undo": "Undo",
    "redo": "Redo",
    "copy_map_objects": "Copy/Paste",
    "draw_analysis_line": "Draw line",
    "draw_analysis_polygon": "Draw polygon",
    "draw_rectangle": "Draw rectangle",
    "draw_point": "Draw point",
    "draw_icon": "Draw icon",
    "draw_model": "Draw model",
    "draw_line_model": "Draw line model",
    "snapping_tools": "Snapping settings"
  },
  "sidebarButtonTooltips": {
    "new_layer": "Create layer from template",
    "import_layer": "Import layer(s) from other plans",
    "attribute_data_table": "Attribute data table",
    "toggle_all_layers_visibility": "Toggle all layers visibility",
    "hide_all_layers": "Hide all layers",
    "show_all_layers": "Show all layers",
    "change_log": "Change log"
  },
  "toggleAllLayersVisibilityConfirmation": {
    "title": "Toggle all layers visibility",
    "message": "This will change the visibility of all layers for all users. Are you sure you want to continue?"
  },
  "layerOptionsTooltips": {
    "layer_information": "Layer information",
    "layer_view_options": "Layer view options",
    "hide_layer": "Hide layer",
    "show_layer": "Show layer"
  },
  "backgroundMapSelector": {
    "background_map_options": "Background Options",
    "recommended": "Recommended",
    "configure": "Configure"
  },
  "sitemaps": {
    "no_sitemaps_available": "No sitemaps at this location.\nSitemaps are detailed maps of locations, such as CAD drawings showing the internal layout of a building.",
    "no_sitemaps_available_2": "\nto learn more about adding sitemaps"
  },
  "drawing_tooltips": {
    "title": "Drawing tools",
    "enter_edit_mode": "Click here, then click on the map to start drawing",
    "enter_edit_mode_no_layers": "To start drawing on the map, first create (or select) a layer using the panel on the left",
    "enter_composition_part_1": "Click on the map to add points. Double click or press",
    "enter_composition_part_2": "to finish."
  },
  "search_tooltip": {
    "set_save_title": "Set this location as default for plan?",
    "set_save_content": "The plan will return to this location next time you open it.",
    "set_save_save": "Save view",
    "set_save_dismiss": "Maybe later",
    "save_info_title": "Saved views",
    "save_info_content": "You can manage saved plan views or change the default for your plan from the search menu.",
    "save_info_got_it": "Got it"
  },
  "attributes": {
    "allowed_metadata_properties": "Allowed Metadata Properties",
    "required": "Required",
    "system_datafield_type": "System Datafield Type"
  },
  "map_tour": {
    "tip_3_location": {
      "title": "Find a location",
      "content": "Here, you can search for places on the plan such as streets, places, or objects you've placed. You can also save important locations to jump to, and set a default for your plan."
    },
    "tip_4_background": {
      "title": "Choose your map background",
      "content": "Here, you can choose from different map backgrounds, like satellite imagery or local mapping providers. You can also set the default background."
    },
    "tip_5_layer": {
      "title": "Create your first layer",
      "content": "To start drawing, create a new layer."
    }
  },
  "zoomableValues": {
    "fixed": "Fixed",
    "by_zoom_level": "By Zoom Level",
    "edit_zoom_levels": "Edit zoom levels",
    "predefined": "Predefined",
    "custom": "Custom",
    "hide": "Hide",
    "add_zoom_level": "Add new zoom level",
    "zoom_options": "Zoom Options",
    "zoom_levels": "Zoom Levels",
    "street_level": "At street level",
    "city_level": "At city level",
    "country_level": "At country level",
    "world_level": "At world level",
    "max_level": "At max zoom level"
  },
  "sidebarToolbar": {
    "share": "Share Plan"
  },
  "units": {
    "pixels": "Pixels",
    "degrees": "Degrees",
    "scale": "Scale",
    "meters": "Meters"
  }
}